import React from 'react';

const InfoCircle: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
        <path d="M 12 2 C 6.48 2 2 6.48 2 12 C 2 17.52 6.48 22 12 22 C 17.52 22 22 17.52 22 12 C 22 6.48 17.52 2 12 2 Z M 13 17 L 11 17 L 11 11 L 13 11 L 13 17 Z M 13 9 L 11 9 L 11 7 L 13 7 L 13 9 Z" />
    </svg>
);

export default InfoCircle;
